import { render, staticRenderFns } from "./Logininfo.vue?vue&type=template&id=724c0b5e&scoped=true&"
import script from "./Logininfo.vue?vue&type=script&lang=js&"
export * from "./Logininfo.vue?vue&type=script&lang=js&"
import style0 from "./Logininfo.vue?vue&type=style&index=0&id=724c0b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724c0b5e",
  null
  
)

component.options.__file = "Logininfo.vue"
export default component.exports